import { render, staticRenderFns } from "./myHome.vue?vue&type=template&id=be5a3216&scoped=true&"
import script from "./myHome.vue?vue&type=script&lang=js&"
export * from "./myHome.vue?vue&type=script&lang=js&"
import style0 from "./myHome.vue?vue&type=style&index=0&id=be5a3216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5a3216",
  null
  
)

export default component.exports